import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './home-page/home-page.component';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  {
    path: '',
    // component: HomeComponent,
    redirectTo: 'home',
    pathMatch: 'full',

   },
   {
    path:"home",
        component: HomeComponent,
        children: [
          {
            path: '',
            component: HomePageComponent,
          },
        ]
   }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
